module.exports = __webpack_public_path__ + "static/img/9.60d13f4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/eng/9.png
// module id = 9D6B
// module chunks = 0